import styled from 'styled-components';
import dynamic from 'next/dynamic';

import CustomIcon from '@components/utils/CustomIcon';
const NextLink = dynamic(() => import('next/link'));
export const BreadcrumbLink = styled.span`
  cursor: pointer;
`;

export const BreadcrumbText = styled.span`
  font-weight: 600;
`;
export const Name = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  & a {
    color: ${({ theme }) => theme.palette.brownishGrey};
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: fit-content;
    max-width: 80vw;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: fit-content;
    max-width: 180px;
  }
`;

export const NameGift = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.white};
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: fit-content;
    max-width: 80vw;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: fit-content;
    max-width: 180px;
  }
`;

export const Container = styled.ul`
  display: flex;
  margin-top: 15px;
  padding: 0;
`;
export const Wrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    overflow: auto;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const NextArrow = styled(CustomIcon)`
  margin: 0 6px;
`;

export const BreadcrumbItem = styled.li`
  display: flex;
  & > a {
    text-decoration: none !important;
  }
`;
export const BreadcrumbItemDetail = styled.li`
  display: flex;
`;
export const BreadCrumbLink = styled(NextLink)`
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: flex;
`;
